/**
 * This component just glues the redux-forms and react-bootstrap form
 * implementations together
 * https://github.com/react-bootstrap/react-bootstrap/issues/2210#issuecomment-246933578
 */
import React, { Component } from 'react';
import FormControl from 'react-bootstrap/lib/FormControl';

class FieldFormControl extends Component {
  render() {
    const {
      children,
      className,
      componentClass,
      input,
      meta: { error, touched },
      onInputChange,
      onPaste,
      name,
      placeholder,
      readOnly,
      type,
    } = this.props;
    const inputProps = {
      inputRef: node => {
        this.inputField = node;
      },
      className,
      name,
      placeholder,
      value: input.value,
      onChange: e => {
        input.onChange(e);
        onInputChange && onInputChange(e);
      },
      onPaste,
      readOnly,
    };
    if (componentClass) {
      inputProps.componentClass = componentClass;
    }
    if (type) {
      inputProps.type = type;
    }

    return <FormControl {...inputProps}>{children}</FormControl>;
  }
}

export default FieldFormControl;
